import { ScoreModel } from './score-model';

export interface OthersScoreModel {
  groupName: string;
  results: ScoreModel[][];
  numberOfCompleteResponses: number;
  respondentNames: string;
  respondentNamesList: string[];
}
